import { z } from 'zod';

import { MENU_SOURCES } from 'features/onboarding/types/onboarding.types';

/**
 * Final step before review: how the partner provides their menu, the optional
 * photo-shoot request, and the (optional) business logo. Lives on the
 * `businessQuestions` section (the logo is handled by the document uploader).
 */
export const stepMenuSchema = z
  .object({
    menuSource: z.enum(MENU_SOURCES, {
      errorMap: () => ({ message: 'required' }),
    }),
    menuWebsiteUrl: z.string().optional().or(z.literal('')),
    menuFile: z
      .object({
        name: z.string(),
        type: z.string(),
        size: z.number(),
        url: z.string(),
        uploadedAt: z.string(),
      })
      .optional(),
    posType: z.string().optional().or(z.literal('')),
    wantsMenuPhotoShoot: z.boolean({ required_error: 'required' }),
  })
  .refine(
    (d) =>
      d.menuSource !== 'website' || (d.menuWebsiteUrl?.trim().length ?? 0) > 0,
    { path: ['menuWebsiteUrl'], message: 'required' },
  )
  .refine((d) => d.menuSource !== 'upload' || !!d.menuFile, {
    path: ['menuFile'],
    message: 'documentRequired',
  })
  .refine(
    (d) => d.menuSource !== 'pos' || (d.posType?.trim().length ?? 0) > 0,
    { path: ['posType'], message: 'required' },
  );

export type StepMenuInput = z.infer<typeof stepMenuSchema>;
